import React from "react";
import { useSelector } from "react-redux";
import InputText from "../inputText";

const InputRotation = ({ value, setRotation, ...params }) => {
  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.stepThree.gradient,
  }));

  const handleChange = (e) => {
    const inputValue = e.target.value;
    if (!inputValue.length) {
      setRotation(null);
    } else if (Number(inputValue) >= 0 && Number(inputValue) <= 360) {
      setRotation(Number(inputValue) * (Math.PI / 180));
    } else if (Number(inputValue) < 0) {
      setRotation(0);
    } else if (Number(inputValue) > 360) {
      setRotation(360 * (Math.PI / 180));
    } else {
      e.preventDefault();
    }
  };

  return (
    <InputText
      type="number"
      min={0}
      max={360}
      step={1}
      onKeyDown={(e) => e.keyCode === 69 && e.preventDefault()}
      placeholder={lang[4]}
      popoverText={null}
      className="mb-0"
      onChange={handleChange}
      value={value !== null ? Math.round(value * (180 / Math.PI)) : ""}
      {...params}
    />
  );
};

export default InputRotation;
